import {MatDialogConfig} from '@angular/material/dialog';
import {
  Project,
  ProjectActionOption,
  ProjectStep,
  ProjectViewRepeatingTaskHistoryDetailParams,
} from 'src/app/core/model/project';

export const DURATION_OPTIONS = [
  '15',
  '30',
  '45',
  '60',
  '75',
  '90',
  '105',
  '120',
  '135',
  '150',
  '165',
  '180',
  '195',
  '210',
  '225',
  '240',
];

export const OPERATOR_OPTIONS = [
  {
    display: 'Equal to',
    displayValue: '=',
    value: 'eq',
  },
  {
    display: 'Less than',
    displayValue: '<',
    value: 'lt',
  },
  {
    display: 'Less than or equal to',
    displayValue: '<=',
    value: 'lte',
  },
  {
    display: 'Greater than',
    displayValue: '>',
    value: 'gt',
  },
  {
    display: 'Greater than or equal to',
    displayValue: '>=',
    value: 'gte',
  },
];

export const BOOLEAN_OPTIONS = [
  {
    display: 'Yes',
    value: '1',
  },
  {
    display: 'No',
    value: '0',
  },
];

export const YES_NO_OPTIONS = [
  {
    display: 'yes',
    value: '1',
  },
  {
    display: 'no',
    value: '0',
  },
];

export const EMPTY_PROJECT_STEP: ProjectStep = {
  name: 'Step',
  previousStepRequired: false,
  tasks: [],
  status: 'inactive',
  alerts: [],
  activationTracker: null,
  completionTracker: null,
};

export const EMPTY_PROJECT: Project = {
  label: 'Untitled_1',
  color: '#B8B8B8',
  steps: [{...EMPTY_PROJECT_STEP}],
  startDateTime: null,
  endDateTime: null,
  status: 'active',
  program: [],
};

export const EMPTY_CHALLENGE: Project = {
  ...EMPTY_PROJECT,
  status: 'inactive',
  isChallenge: true,
  challengeBuilder: {
    initialGoal: '',
    goals: [],
    objectives: [],
    tasks: [],
    metrics: [],
  },
  winConditions: {
    cycleSuccessScore: 80,
    levelProgressThreshold: 1,
  },
};

export const PROJECT_WIZARD_DIALOG_CONFIG: MatDialogConfig = {
  backdropClass: 'oph-backdrop',
  panelClass: 'schedule-project-dialog',
  width: '720px',
  maxWidth: '720px',
  height: '652px',
  maxHeight: '652px',
  disableClose: true,
};

export const PROJECTS_DIALOG_CONFIG: MatDialogConfig = {
  backdropClass: 'oph-backdrop',
  panelClass: 'projects-dialog',
  width: '100%',
  maxWidth: '720px',
  height: '100%',
  maxHeight: '100%',
  disableClose: true,
};

export const PROJECT_EDIT_ALERTS_DIALOG_CONFIG: MatDialogConfig = {
  backdropClass: 'oph-backdrop',
  panelClass: 'project-edit-alerts-dialog',
  width: '100%',
  maxWidth: '720px',
  height: '100%',
  maxHeight: '654px',
  disableClose: true,
};

export const PROJECT_TARGETS_DIALOG_CONFIG: MatDialogConfig = {
  backdropClass: 'oph-backdrop',
  panelClass: 'schedule-project-dialog',
  width: '720px',
  maxWidth: '720px',
  height: '652px',
  maxHeight: '652px',
  disableClose: true,
  autoFocus: false,
};

export const GOAL_FLOW_TARGET_DIALOG_CONFIG: MatDialogConfig = {
  backdropClass: 'oph-backdrop',
  panelClass: 'goal-flow-target-dialog',
  width: '904px',
  maxWidth: '904px',
  height: '760px',
  maxHeight: '760px',
  disableClose: true,
};

export const PROJECTS_ADD_SKED_DIALOG_CONFIG: MatDialogConfig = {
  backdropClass: 'oph-backdrop',
  panelClass: 'schedule-project-dialog',
  width: '100%',
  maxWidth: '530px',
  minHeight: '540px',
  maxHeight: '90%',
};

export const PROJECTS_USERS_TEAMS_SELECTION_DIALOG_CONFIG: MatDialogConfig = {
  backdropClass: 'oph-backdrop',
  panelClass: 'mobile-dialogs',
  width: '100%',
  maxWidth: '665px',
  height: '100%',
  maxHeight: '680px',
};

export const PROJECT_ACTION_OPTIONS: ProjectActionOption[] = [
  {
    action: 'edit',
    icon: 'pencil-outline',
  },
  {
    action: 'duplicate',
    icon: 'plus',
  },
  {
    action: 'delete',
    icon: 'x-circle',
  },
];

/** Row menu option with label and icon (asset path). */
export interface ProjectRowMenuOption {
  action: string;
  label: string;
  icon: string;
}

/** Project (non-challenge) row menu: Edit, Duplicate, Delete. Uses same icon paths as challenges for Duplicate and Delete. */
export const PROJECT_ROW_MENU_OPTIONS: ProjectRowMenuOption[] = [
  {action: 'edit', label: 'Edit', icon: 'assets/img/icons/edit.svg'},
  {action: 'duplicate', label: 'Duplicate', icon: 'assets/img/icons/projects-menu-duplicate.svg'},
  {action: 'delete', label: 'Delete', icon: 'assets/img/icons/projects-menu-delete.svg'},
];

/** Challenge row menu: Start Over, Stop, Duplicate, Delete. */
export const CHALLENGE_ROW_MENU_OPTIONS: ProjectRowMenuOption[] = [
  {action: 'startOver', label: 'Start Over', icon: 'assets/img/icons/projects-menu-restart.svg'},
  {action: 'stop', label: 'Stop', icon: 'assets/img/icons/projects-menu-stop.svg'},
  {action: 'duplicate', label: 'Duplicate', icon: 'assets/img/icons/projects-menu-duplicate.svg'},
  {action: 'delete', label: 'Delete', icon: 'assets/img/icons/projects-menu-delete.svg'},
];

export const EMPTY_ROUTINE_DETAIL_PARAMS: ProjectViewRepeatingTaskHistoryDetailParams = {
  status: 'all',
  page: 1,
  pageSize: 10,
};

export const EMPTY_TOKEN_FILTER_PARAMS: Record<string, string> = {
  time: '2',
};
